import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { biddingDelivery, getTaskInfo } from '../../api';
export default {
  name: 'BiddingDeliveryDialog',
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        item_id: null,
        status: '',
        delivery_remarks: ''
      },
      rules: {
        status: [{
          required: true,
          message: '请选择交付结果',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(itemId) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, detail, taskStatus;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.form.item_id = itemId;
              _this.form.status = '';
              _this.form.delivery_remarks = '';
              _this.dialogVisible = true;
              _context.n = 1;
              return getTaskInfo({
                item_id: itemId
              });
            case 1:
              res = _context.v;
              detail = res.data || {};
              taskStatus = Number(detail.task_status); // 交付结果：550未交付 600已交付，其余状态回空
              _this.form.status = taskStatus === 550 || taskStatus === 600 ? String(taskStatus) : '';
              _this.form.delivery_remarks = detail.delivery_remarks || '';
              _this.$nextTick(function () {
                _this.$refs.form.clearValidate();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var obj = {
            item_id: _this2.form.item_id,
            status: _this2.form.status,
            delivery_remarks: _this2.form.delivery_remarks
          };
          biddingDelivery(obj).then(function (res) {
            _this2.$message.success('提交成功');
            _this2.dialogVisible = false;
            _this2.$emit('success');
          });
        }
      });
    }
  }
};